export type { LoadingProps } from "@components/contracts/Loading.types";
export { CelebrationLoading } from "./Loading.adapter";
